import { useQuery } from '@apollo/client'
import { Divider } from '../base/divider'
import { Heading } from '../base/heading'
import { IntegrationProviderCategoriesQuery } from './__generated__/collection_query'
import { Query } from './collection_query'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { Integration } from './integration'

export const Collection = () => {
  const { data, loading, error } = useQuery<IntegrationProviderCategoriesQuery>(Query, {})

  if (error) return <Error message={error.message} />
  if (loading || !data) return <Loading />

  return (
    <div className="flex flex-col gap-6">
      { data.integrationProviderCategories.map((category, i) => (
        <>
          <div className="flex flex-col gap-4">
            <Heading>{ category.name }</Heading>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
              { category.integrationProviders.map(provider => <Integration integrationProvider={provider} />) }
            </div>
          </div>
          { i < (data.integrationProviderCategories.length - 1) && <Divider /> }
        </>
      ))}
    </div>
  )
}
